import { useEffect, useState } from 'react';
import './App.css';
import { Convert, Profile } from './Model/Convert';
import ArticleView from './Views/ArticleView';
import SectionView from './Views/SectionView';

function App() {

  useEffect(() => {

    const profileDataFetch = fetch('data/profile.json')
      .then(res => res.text())
      .then(res => {
        try {
          return Convert.toProfile(res)
        } catch (e) {
          console.log("❌📝 - [Profile] Deserialization failed", e)
          return Promise.reject("Deserialization failed")
        }

      })

    profileDataFetch.then(profile => {
      setProfile(profile)
    })

  }, [])

  const [profile, setProfile] = useState<Profile>()

  const defaultForegroundColor = [32, 32, 32]
  const defaultBackgroundColor = [255, 255, 255]

  const appForegroundColor = () => {
    const foregroundColor = profile?.foregroundColor || defaultForegroundColor
    return `rgb(${foregroundColor[0]}, ${foregroundColor[1]}, ${foregroundColor[2]})`
  }

  const appBackgroundColor = () => {
    const backgroundColor = profile?.backgroundColor || defaultBackgroundColor
    return `rgb(${backgroundColor[0]}, ${backgroundColor[1]}, ${backgroundColor[2]})`
  }

  const getTimePeriodTitle = (from?: Date, to?: Date): string => {

    var title = ""

    if (from !== undefined) {
      title = from.toLocaleDateString("en-US", { month: 'long', year: "numeric" }) + " - " + (to === undefined ? "Now" : to.toLocaleDateString("en-US", { month: 'long', year: "numeric" }))
    }
    return title
  }

  return (
    <div className="App">
      <header className="App-header" style={{ backgroundColor: appBackgroundColor(), color: appForegroundColor() }}>
        {
          profile === undefined ?
            <div>

            </div>
            :
            <div style={{ margin: '16px' }}>
              <div style={{ margin: '50px' }}>
                <img src={profile.thumbnailImageUrl} style={{ borderRadius: '50%', width: '80%', maxWidth: '350px', padding: 16, boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px" }}></img>
                <h1>{profile.firstName + " " + profile.lastName}</h1>
                <h2>{profile.occupations.join(", ")}</h2>
                {
                  profile.reachOut.map(reachOut => {
                    return (
                      <div style={{ fontWeight: '600', maxHeight: 25, cursor: 'pointer', display: 'inline-block', padding: 16, margin: 16, borderRadius: 5, boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px" }} onClick={() => { window.open(reachOut.dedicatedPageUrl) }}>
                        {reachOut.thumbnailImageUrl &&
                          <img style={{ height: 20 }} src={reachOut.thumbnailImageUrl}></img>
                        }
                        {reachOut.title &&
                          <>{reachOut.title}</>
                        }
                      </div>)
                  })
                }
              </div>

              {profile.workplaces.map(workplace => {
                return (
                  <SectionView thumnailImageUrl={workplace.thumbnailImageUrl} title={workplace.name} description={getTimePeriodTitle(workplace.startDate, workplace.endDate)} foregroundColor={workplace.foregroundColor || defaultForegroundColor} backgroundColor={workplace.backgroundColor || defaultBackgroundColor}>
                    {
                      workplace.projects.map(project => {
                        return (
                          <ArticleView onTouch={project.dedicatedPageUrl === undefined ? undefined : () => { window.open(project.dedicatedPageUrl) }} thumnailImageUrl={project.thumbnailImageUrl} title={project.name || ""} subtitle={project.company || ""} subsubtitle={project.position || ""} description={project.shortDescription + (project.jobDescription == undefined ? "" : ("\n\n" + project.jobDescription))} footer={getTimePeriodTitle(project.startDate, project.endDate)} foregroundColor={project.foregroundColor || defaultForegroundColor} backgroundColor={project.backgroundColor || defaultBackgroundColor} />
                        )
                      })
                    }
                  </SectionView>
                )
              })}
            </div>
        }
        <footer style={{ padding: 16, fontSize: "0.7em" }}>Written in React & TypeScript, Copyright © Kevin Varga Halász</footer>
      </header>
    </div>
  );
}

export default App;
